import { render, staticRenderFns } from "./PostV3.vue?vue&type=template&id=8c1a95ec&"
import script from "./PostV3.vue?vue&type=script&lang=js&"
export * from "./PostV3.vue?vue&type=script&lang=js&"
import style0 from "./PostV3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports